export const BUSINESS_UNITS = [1, 2];
